import { Group, Image } from '@mantine/core'
import shell from '~/boggle/ui/chrome/RouteShell.module.css'
import styles from './Logo.module.css'

export type LogoProps = {
  titleClassName?: string
  /** Larger landing-page treatment */
  variant?: 'default' | 'hero'
}

const LOGO_WIDTH = 300
const LOGO_HEIGHT = 144

/** Stylized “Patter” wordmark, shared by route headers and the hub landing. */
export function Logo({ titleClassName, variant = 'default' }: LogoProps) {
  const titleClassList = [shell.title, styles.mark, titleClassName].filter(Boolean).join(' ')
  const rootClass = [styles.wrap, variant === 'hero' ? styles.hero : null]
    .filter(Boolean)
    .join(' ')

  return (
    <Group className={rootClass} align="center" justify="center" wrap="nowrap">
      <Image
        alt="Patter"
        fit="contain"
        h="auto"
        mah={LOGO_HEIGHT}
        miw={0}
        maw={LOGO_WIDTH}
        src="/logo.png"
        w="100%"
        width={LOGO_WIDTH}
        height={LOGO_HEIGHT}
      />
    </Group>
  )
}
